import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const roleGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const userRole = localStorage.getItem('userType');
  const allowedRoles = route.data['roles'] as string[];

  // 1. Valid Authorization Pass
  if (userRole && allowedRoles && allowedRoles.includes(userRole)) {
    return true;
  }

  // 2. Break the Infinite Loop: Absolute matching redirects
  if (userRole === 'app_admin') {
    return router.createUrlTree(['/dashboard']); // Added /dashboard/
  }

  if (userRole === 'application_user') {
    return router.createUrlTree(['/dashboard/api-test']); // Added /dashboard/
  }

  return router.createUrlTree(['/login']);
};
